import * as React from 'react';
import { DownIcon, UpIcon } from '@fluentui/react-icons-mdl2';
import { CREATE_MODAL_FIED_VALIDATION, METRIC_DIRECTIONS, METRIC_WIZARD_CATEGORY } from './CreateModal.constants';
import EnvironmentService from '@ane/core/lib/services/EnvironmentService';
export const directionIcon = (direction) => {
    switch (direction) {
        case METRIC_DIRECTIONS.Decrease:
            return React.createElement(DownIcon, null);
        case METRIC_DIRECTIONS.Increase:
            return React.createElement(UpIcon, null);
        default:
            return React.createElement(React.Fragment, null);
    }
};
export const parseMetricField = (metricField) => {
    return !!metricField ? metricField.split(',') : [];
};
export const addExperienceCategory = (metadata) => {
    return Object.assign(Object.assign({}, metadata), { categories: metadata.categories.includes(METRIC_WIZARD_CATEGORY)
            ? metadata.categories
            : metadata.categories.concat(METRIC_WIZARD_CATEGORY) });
};
export const enableMetricWizardForEditClone = (categories) => {
    return (EnvironmentService.disableMetricsWizardExperienceCheck() || (!!categories && categories.includes(METRIC_WIZARD_CATEGORY)));
};
export const validateInternalName = (internalName, metricNames) => {
    let errorMessage = '';
    if (!(internalName === null || internalName === void 0 ? void 0 : internalName.length)) {
        errorMessage = 'Required';
    }
    else if (!internalName.match(CREATE_MODAL_FIED_VALIDATION.internalName.pattern.value)) {
        errorMessage = CREATE_MODAL_FIED_VALIDATION.internalName.pattern.message;
    }
    else if (metricNames.some((name) => name === internalName)) {
        errorMessage = CREATE_MODAL_FIED_VALIDATION.internalName.duplicate;
    }
    return errorMessage;
};

//# sourceMappingURL=CreateModal.utils.js.map
